"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const eventsUtils_1 = require("./eventsUtils");
const adminCommandUtils_1 = require("./adminCommandUtils");
class CommandProcessor {
    constructor(accessors, skipValidate) {
        this.accessors = accessors;
        this.processCommand = async (command) => {
            const promise = new Promise((resolve, reject) => {
                // To process a command, we must first validate that the command is accurately signed
                if (this.commandDoesHaveValidSignature(command)) {
                    // Once the signing is validated, pull the appropriate command definition
                    if (this.commandDefinitions[command.aggregateType][command.type]) {
                        const commandDefinition = this.commandDefinitions[command.aggregateType][command.type];
                        // now load the right command version
                        const commandVersion = commandDefinition.versions.find(cmdDef => cmdDef.version === command.version);
                        if (commandVersion) {
                            //  Then ensure that the roles provided have the access to perform the action
                            if (this.commandHasRequiredRoles(command, commandVersion)) {
                                // If there is a command target, validate that the target can accept this command
                                if (command.target && commandVersion.commandIsValidForTarget) {
                                    //load the target from the aggregateLoader
                                    //let aggregate = await this.aggregateLoader.getAggregateState(command.target);
                                    // now run commandDefinition.commandIsValidForTarget(aggregate);
                                }
                                if (!this.skipValidate) {
                                    commandVersion.validateCommand(command, this).then(errs => {
                                        if (errs.length) {
                                            reject('Command failed with the following errors: ' + errs.join(', '));
                                        }
                                        else {
                                            resolve(commandVersion.processCommand(command, this));
                                        }
                                    });
                                }
                                else {
                                    resolve(commandVersion.processCommand(command, this));
                                }
                                // Finally run the process function on the definition to get the events that the command produces
                                //  this would also be a good time to process any side effects
                            }
                        }
                        else {
                            reject(`Could not find command: ${command.type} with version: ${command.version}`);
                        }
                    }
                    else {
                        // command definition not found
                        reject(`Could not find command: ${command.type}`);
                    }
                }
                else {
                    reject(`Command could not be validated at this time`);
                }
            });
            return promise;
        };
        this.commandDefinitions = {};
        this.skipValidate = skipValidate;
    }
    // TODO: Change the name to initFromGen5Config
    initfromGen5Config(gen5Config) {
        var _a;
        // cycle through each of the aggregates and build our command store from there.
        const aggCommandDefs = {};
        gen5Config.aggregates &&
            gen5Config.aggregates.forEach(agg => {
                aggCommandDefs[agg.typeName] = {};
                // Build one static command definition for handling adminUpdates
                aggCommandDefs[agg.typeName]['AdminUpdate'] = (0, adminCommandUtils_1.createAdminUpdateCommand)(agg);
                // Build all of the commands defined in the gen5 config
                if (agg.commands) {
                    Object.keys(agg.commands).forEach(cmdKey => {
                        const versions = agg.commands[cmdKey].versions;
                        aggCommandDefs[agg.typeName][cmdKey] = {
                            versions: versions.map(cmdVer => {
                                const outCmdVer = {
                                    version: cmdVer.version,
                                    processCommand: (0, eventsUtils_1.createProcessCommand)(cmdVer, agg, { accessors: this.accessors }),
                                    validateCommand: (0, eventsUtils_1.createValidateCommand)(cmdVer, { accessors: this.accessors }),
                                };
                                return outCmdVer;
                            }),
                        };
                    });
                }
            });
        this.commandDefinitions = aggCommandDefs;
        this.configFunctions = (_a = gen5Config.functions) !== null && _a !== void 0 ? _a : {};
    }
    commandDoesHaveValidSignature(command) {
        //Here we should validate that the securityToken is provided and that the signature is valid
        //TODO: implement
        if (command) {
            return true;
        }
        return true;
    }
    commandHasRequiredRoles(command, commandDef) {
        // Here we look at the command and the command definition and validate that the roles provided in the command are present in the required roles of the command definition
        // We may want to in the future also check any parent containers for required roles
        //TODO: implement
        if (command || commandDef) {
            return true;
        }
        return true;
    }
}
exports.default = CommandProcessor;
//# sourceMappingURL=CommandProcessor.js.map